// Test IDs for the home / landing page.

export const HOME = {
    // legacy from template
    emergentLink: "home-emergent-link",
    // hero
    heroPrimaryCta: "hero-primary-cta",
    heroWhatsappCta: "hero-whatsapp-cta",
    heroCallCta: "hero-call-cta",
    heroForm: "hero-quote-form",
    heroFormSubmit: "hero-quote-form-submit",
    // sections
    servicesSection: "services-section",
    servicesCard: "services-card",
    faqAccordion: "faq-accordion",
    faqItemTrigger: "faq-item-trigger",
    finalCtaPrimary: "final-cta-primary-button",
    finalCtaWhatsapp: "final-cta-whatsapp-button",
    reviewsPlaceholder: "reviews-placeholder",
};
